<template>
	<div
		class="maintenance-screen d-flex align-items-center justify-content-center"
	>
		<div class="maintenance-panel text-center px-3">
			<div class="display-icon mb-3">
				<i class="bi bi-tools"></i>
			</div>
			<h1 class="h3 fw-semibold mb-3">System is undergoing maintenance</h1>
			<p v-if="message" class="gate-message mb-3">{{ message }}</p>
			<p class="text-muted explanation mb-1">
				<template v-if="origin === 'restore'">
					Cached and derived data is being rebuilt from the restored database.
					Access to the dashboard returns automatically once the rebuild
					completes.
				</template>
				<template v-else>
					Administrative maintenance is in progress. Access returns
					automatically once the work is complete.
				</template>
			</p>
			<p class="text-muted small status-note mb-0">
				<i class="bi bi-arrow-repeat me-1"></i>
				This page updates automatically while maintenance runs
				<template v-if="startedAt">
					— started {{ formatStarted(startedAt) }}</template
				>.
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
interface Props {
	message: string | null;
	origin: "restore" | "manual" | null;
	startedAt: string | null;
}
defineProps<Props>();

function formatStarted(iso: string): string {
	return new Date(iso).toLocaleString();
}
</script>

<style scoped lang="scss">
.maintenance-screen {
	min-height: 100vh;
	background-color: $off-white;
}

.maintenance-panel {
	max-width: 600px;
}

.display-icon {
	font-size: 3.5rem;
	color: $primary;
}

.gate-message {
	font-size: 1.15rem;
	font-weight: 500;
}

.explanation {
	font-size: 1rem;
}
</style>
